/**
 * Global MUTABLE support object
 * For tests, override the getFeature function and not the object
 * @type {{isWEBP: {lossless: boolean, lossy: boolean, alpha: boolean, animation: boolean}}}
 */
var globalFeaturesSupportObj = {
    /**
     * checks if the browser supports webp image type
     * @type {object<boolean>}
     */
    isMobile: false,
};
var getFeature = function (feature) {
    return globalFeaturesSupportObj[feature];
};
var setFeature = function (feature, value) {
    globalFeaturesSupportObj[feature] = value;
};
export { getFeature, setFeature };
//# sourceMappingURL=imageServiceFeatureSupportObject.js.map